import { ENV } from "../config/env";

export const BASE_URL = ENV.BASE_URL;
export const PATIENT_PORTAL = ENV.PATIENT_PORTAL;
export const OHC_REDIRECT = ENV.OHC_REDIRECT;
export const OHC_BASE_URL = ENV.OHC_BASE_URL;
export const LOGIN = "/auth/login";
export const FORGOT_PASSWORD = "/forgot-password/send-otp";
export const VERIFY_OTP = "/forgot-password/verify-otp";
export const CHANGE_PASSWORD = "/forgot-password/change-password";
export const CHANGE_PASSWORD_INSIDE = "/forgot-password/change_password";
export const RESEND_OTP = "/resend-otp/send";
export const HELP_SEND_EMAIL = "/hr/send-email";
export const UPLOAD_FILE = "/data/upload";
export const GET_PROFILE = "/hr/profile";
export const UPDATE_PROFILE = "/hr/updateHrProfile";
export const GET_MASTER = "/data/patient";
export const GET_STATE = "/data/states-hr";
export const GET_CITY = "/data/cities-hr";
export const GET_NOTIFICATION = "/notify/notifications";
export const REMOVE_NOTIFICATION = "/notify/removeNotification";
export const UPDATE_READ_NOTIFICATION = "/notify/updateReadNotification";
export const ADD_PRE_EMPLOYEE = "/hr/add-pre-employee";
export const GET_PRE_EMPLOYEE = "/hr/preEmployee";
export const GET_ASSESSMENT_HRA = "/hr/assesmentHra";
export const GET_DOC_CONSULTANCY = "/hr/doctorConsultancy";
export const GET_HEALTH_RISK = "/hr/healthRisk";
export const MANAGE_EMPLOYEE = "/hr/manageEmployee";
export const ADD_EMPLOYEE = "/hr/addEmployee";
export const ENABLE_DISABLE_EMPLOYEE = "/hr/disableEnableEmployee";
export const EMPLOYEE_ENGAGEMENT = "/hr/employeeEngagement";
export const SEND_REMINDER = "/hr/sendReminder";
export const SSO_LOGIN_OHC = "/auth/ssologin";
export const USER_MODULE = "/hr/user-module";
